export default class FilterDropdown {
  constructor(el) {
    this.el = el;
    this.search = null;
    this.menu = null;
    this.values = [];
    this.selectedValue = null;
    this.init();
    this.initEvents();
  }

  init() {
    this.search = this.el.querySelector("input.search");
    this.menu = this.el.querySelector(".menu");
    var items = this.menu.childNodes;
    items.forEach((item) => {
      this.values.push(item);
    });
    this.selectedValue = this.el.querySelector(".selected");
  }

  initEvents() {
    this.search.removeEventListener("input", (e) =>
      this.changeDropdown(e.target)
    );
    this.search.addEventListener("input", (e) => this.changeDropdown(e.target));
    this.search.addEventListener("click", (e) => {
      e.preventDefault();
      this.toggleDropdown(e.target);
    });

    this.values.forEach((item) => {
      item.addEventListener("click", (e) => {
        e.preventDefault();
        this.changeSelectedValue(e);
      });
    });

    document.addEventListener("click", (e) => {
      var isClickInside = this.el
        .querySelector(".menu")
        .parentNode.contains(e.target);

      if (!isClickInside) {
        if (
          this.search.parentNode.classList.contains("visible") &&
          this.search.parentNode.classList.contains("active")
        ) {
          this.toggleDropdown(this.search);
        }
      }
    });
  }

  changeDropdown(search) {
    var error = this.menu.querySelector(".message");
    if (error != null) {
      this.menu.removeChild(error);
    }

    var counter = 0;
    this.values.forEach((item) => {
      item.classList.add("filtered");
      if (item.textContent.toLowerCase().includes(search.value.toLowerCase())) {
        item.classList.toggle("filtered");
        counter++;
      }
    });
    if (counter === 0) {
      var message = document.createElement("div");
      message.classList.add("message");
      message.textContent = "No results found.";
      this.menu.appendChild(message);
    }
  }

  toggleDropdown(e) {
    this.el.querySelector("div.search").classList.toggle("visible");
    this.el.querySelector("div.search").classList.toggle("active");
    this.el.querySelector(".menu").classList.toggle("hidden");
    this.el.querySelector(".menu").classList.toggle("visible");
  }

  changeSelectedValue(e) {
    e.target.classList.toggle("active");
    e.target.classList.toggle("selected");

    this.selectedValue.classList.toggle("active");
    this.selectedValue.classList.toggle("selected");
    this.selectedValue = e.target;
    this.search.placeholder = e.target.innerHTML;
    this.toggleDropdown(this.search);
  }
}
